// extracted by mini-css-extract-plugin
export default {"container":"styles_container__uFqfc","container__title":"styles_container__title__670Dm","firstBlock":"styles_firstBlock__uPLSc"};